import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { Tooltip } from "react-tooltip";
import { truncateText, capitalizeFirstLetter } from "../../helpers";
import NotFoundModel from "../NotFoundModel";
import { MdDelete, MdEdit } from "react-icons/md";
import { IoMdMore } from "react-icons/io";

const BankListTable = ({
    apiData,
    setSelectedData,
    setIsDeleteBank,
    setIsEditBank
}) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const [previousId, setPreviousId] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const deleteBank = (item) => {
        setIsDeleteBank(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const edit = (item) => {
        setIsEditBank(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        const openMenu = (id) => {
            setPreviousId(openActionMenu);
            setOpenActionMenu((prevId) => {
                return prevId === id ? null : id;
            });
        };

        return (
            <ActionBtnWrapper>
                {openActionMenu === item.id && (
                    <MenuOptions id="menuOptions">
                        <MenuItem
                            title="Edit Details"
                            onClick={() => edit(item)}
                        >
                            <MdEdit className="text-gray-700 " /> Edit Details
                        </MenuItem>
                        <MenuItem
                            title="KYC Details"
                            onClick={() => deleteBank(item)}
                        >
                            <MdDelete className="text-gray-700 " /> Delete
                        </MenuItem>
                    </MenuOptions>
                )
                }
                <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
                    <IoMdMore className="text-gray-600" size={24} />
                </Btn>
            </ActionBtnWrapper >
        );
    };
    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                holderName: getName(item),
                branchAddress: getAddress(item),
                bankName: item.bankName ? item.bankName : "--",
                accountNumber: item.accountNum,
                ifsc: item.ifsc,
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const getName = (item) => {
        return (
            <UserImageWrapper >
                <div className="flex-row flex">
                    <UserImage src={Images.Avatar} alt={`Avatar for ${item.holderName}`} />
                </div>
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm font-medium">
                        {item?.holderName?.charAt(0).toUpperCase() + item?.holderName?.slice(1)}{" "}
                    </span>

                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">#{item.accountNum}</span>

                    </div>
                </div>
            </UserImageWrapper>
        );
    };



    const getAddress = (item) => {
        return item.bankAddress ? (
            <div className="text-sm text-gray-600">
                <div className="flex">
                    <span
                        data-tooltip-id={`tooltip-${item.id}`}
                        data-tooltip-content={item.bankAddress}
                        data-tooltip-delay-show={500}
                        data-tooltip-place="top"
                        data-tooltip-variant="info"
                        className="text-gray-600 text-sm"
                    >
                        {capitalizeFirstLetter(truncateText(item.bankAddress, 18))}
                    </span>
                </div>

                <Tooltip
                    id={`tooltip-${item.id}`}
                    className="max-w-[70%] md:max-w-[50%] xl:max-w-[40%] 2xl:max-w-[20%]"
                />
            </div>
        ) : (
            "--"
        );
    };


    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Name & Account Number",
                    accessor: "holderName",
                },
                {
                    Header: "IFSC Code",
                    accessor: "ifsc",
                },
            ];
        }
        return [
            {
                Header: "Name & Account Number",
                accessor: "holderName",
            },


            {
                Header: "IFSC Code",
                accessor: "ifsc",
            },
            {
                Header: "Bank",
                accessor: "bankName",
            },
            {
                Header: "Bank Address",
                accessor: "branchAddress",
            },

            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    style={column.style}
                                >
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                style={cell.column.style}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">

                                                <li>
                                                    <strong>Bank Name:</strong> {data[rowIndex].bankName}
                                                </li>
                                                <li>
                                                    <strong>Bank Address:</strong> {data[rowIndex].branchAddress}
                                                </li>
                                                <li>
                                                    <strong>Delete</strong>{" "}
                                                    {data[rowIndex].action}
                                                </li>


                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
            {apiData?.length === 0 && <NotFoundModel />}
        </>
    );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer`;
const UserImage = tw.img`w-10 h-10 rounded-full `;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-10 rounded-lg shadow-lg border border-gray-200 flex flex-col`;

export default BankListTable;
